import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { SelectEntity } from '@ozgene/gp5.components.select-entity';

export default function SelectUser(props) {
  const {
    getEntities,
    value,
    onChange,
    label,
    users,
    useUsername,
    ...restProps
  } = props;
  const getEntitiesCallback = useCallback(
    async () => (users ? users : getEntities ? getEntities() : []),
    [users]
  );
  const getOptionLabel = (user) =>
    useUsername
      ? user.username + ` (${user.firstName} ${user.lastName})`
      : user.firstName + ' ' + user.lastName;

  return (
    <SelectEntity
      getEntities={getEntitiesCallback}
      value={value}
      onChange={onChange}
      label={label}
      getOptionLabel={getOptionLabel}
      {...restProps}
    />
  );
}

SelectUser.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      username: PropTypes.string,
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        username: PropTypes.string,
      })
    ),
  ]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  users: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })
  ),
  useUsername: PropTypes.bool,
  getEntities: PropTypes.func,
};

SelectUser.defaultProps = {
  value: null,
  label: 'User',
  users: null,
  useUsername: false,
  getEntities: null,
};
